import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  DatePicker,
} from 'antd';
import ModalFechaObservacionControls from './ModalFechaObservacionControls';

const requiredRule = {
  required: true,
  message: 'El campo es requerido',
};

const rules = {
  required: [requiredRule],
};

const ModalFechaObservacion = ({
  form, onPutDate, title, open, onCancel, fechaKey, observacionRequerida, subTitle,
}) => (
  <Modal
    width={540}
    title={(
      <Row justify="space-between" align="middle">
        <ModalFechaObservacionControls
          label={`Agregar ${title}`}
          onSave={onPutDate}
          onCancel={onCancel}
        />
      </Row>
    )}
    className="modal-delete"
    open={open}
    footer={null}
    closable={false}
  >
    <Form
      layout="vertical"
      form={form}
    >
      <Row
        gutter={10}
        style={{ paddingBottom: '.1rem' }}
      >
        <Col span={24}>
          <Form.Item
            name={fechaKey}
            label={`Fecha de ${subTitle}`}
            rules={rules.required}
            hasFeedback
          >
            <DatePicker
              allowClear
              format="DD/MM/YYYY"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row
        gutter={10}
        style={{ paddingBottom: '.1rem' }}
      >
        <Col span={24}>
          <Form.Item
            name="observaciones"
            label="Observaciones"
            rules={observacionRequerida ? rules.required : null}
            hasFeedback
          >
            <Input.TextArea
              allowClear
              autoSize={{ minRows: 2, maxRows: 3 }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  </Modal>
);

ModalFechaObservacion.propTypes = {
  form: PropTypes.shape,
  onPutDate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  fechaKey: PropTypes.string,
  open: PropTypes.bool,
  observacionRequerida: PropTypes.bool,
};

ModalFechaObservacion.defaultProps = {
  form: {},
  title: '',
  subTitle: '',
  fechaKey: '',
  open: false,
  observacionRequerida: false,
};

export default ModalFechaObservacion;
